export default __webpack_public_path__ + "static/trust-badge-6dc99273c4eb2dd60bbd74d489038777.png";